import { Pagination, PaginationPageSizes } from "best-common-react";
import React from "react";
import { useSearch } from "../../contexts/SearchContext";

const SearchPagination = () => {
  const { pagination, setPagination } = useSearch();

  return (
    <div className="bcr-mt-5 d-flex justify-content-end">
      {pagination.totalCount > 0 && (
        <Pagination
          pagination={{
            totalItems: pagination.totalCount,
            pageNumber: pagination.pageNumber,
            setPageNumber: (value: number) => setPagination({ ...pagination, pageNumber: value }),
            pageSize: pagination.pageSize,
            setPageSize: (value: PaginationPageSizes) => setPagination({ ...pagination, pageSize: value }),
          }}
        />
      )}
    </div>
  );
};

export default SearchPagination;
